<template>
  <div class="standings-round-list-section">
    <template v-if="roundsRecords && roundsRecords.length > 0">
      <standings-round-details-section
        class="standings-round-list-section__item"
        v-for="(round, index) in roundsRecords"
        :key="`standingsRoundDetails${index}`"
        :roundRecord="round"
      />
    </template>
    <template v-else>
      <p class="standings-round-list-section__no-data" v-html="$tc('StandingsPage.noData')"></p>
    </template>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from '@vue/composition-api'
import StandingsRoundDetailsSection, {
  StandingsRoundDataType,
} from '@/components/StandingsPage/StandingsRoundDataPane/StandingsRoundDetailsSection.vue'

/**
 * Standings: レース一覧 セクション
 */
export default defineComponent({
  name: 'StandingsRoundListSection',
  components: {
    StandingsRoundDetailsSection,
  },
  props: {
    roundsRecords: {
      type: Array as PropType<StandingsRoundDataType[]>,
    },
  },
})
</script>

<style lang="scss" scoped>
.standings-round-list-section {
  display: flex;
  flex-flow: row wrap;
  align-items: flex-start;
  justify-content: center;
  gap: min(#{convertPXtoVW(12)}, 12px);
  width: min(100%, 740px);
  margin: 0 auto;

  &__no-data {
    padding: 7px 0;
    font-family: $fontSignup;
    font-weight: 500;
    font-size: 12px;
    line-height: 1.67;
    text-align: center;
    letter-spacing: 0.02em;
    font-feature-settings: 'palt' on;
    color: $gray50;
  }

  @media screen and (min-width: $responsiveTabletWidth - 1px) {
    gap: 24px;

    &__item {
      width: calc(50% - 12px);
    }
  }
}
</style>
